module.exports = __webpack_public_path__ + "static/media/about_us_w_circle.280eb9a7.svg";